<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2>Recibo</h2>
      </div>
      <div class="col-md-6 text-right">
        <h2>R$ {{ formatMoney(String(data.total)) }}</h2>
      </div>
    </div>
    <div v-for="(item, key) in items" :key="key">
      <p class="worksansr m-0">
        Recebi de
        <b>
          {{
            item.spent_or_gain == "CREDITO"
              ? item.finance_client_name
                ? item.finance_client_name
                : "[CLIENTE NÃO INFORMADO]"
              : item.provider_company_name
              ? item.provider_company_name
              : "[FORNECEDOR NÃO INFORMADO]"
          }}</b
        >, a importância de R$ {{ formatMoney(String(item.value)) }} (<b>{{
          handleTextValue(item)
        }}</b
        >), referente o(a): <b> {{ item.description }}</b
        >.
      </p>
      <p class="worksansr m-0">
        Dou plena e geral quitação dos débitos aos quais este recibo se refere.
      </p>
      <p class="worksansr text-right">
        {{
          user.rest_home_uf && user.rest_home_uf.name
            ? user.rest_home_uf.name
            : ""
        }}
        -
        {{
          user.rest_home_uf && user.rest_home_uf.initials
            ? user.rest_home_uf.initials
            : ""
        }}, ____/____/______
      </p>
      <p class="worksansr text-right mt-3 mb-0 text-uppercase">
        ___________________________________________
        <br />
        {{
          item.spent_or_gain == "CREDITO"
            ? user.rest_home_name
            : item.provider_company_name
            ? item.provider_company_name
            : "[FORNECEDOR NÃO INFORMADO]"
        }}
      </p>
      <p class="worksansr m-0 text-right" v-if="item.spent_or_gain == 'DEBITO'">
        {{ item.provider_cpf_cnpj }}
      </p>
      <hr />
    </div>
    <div class="row">
      <div class="col-md-6 pt-0 pb-0">
        <p class="m-0 worksansr">{{ user.rest_home_fantasy_name }}</p>
        <p class="m-0 worksansr">{{ user.rest_home_cnpj }}</p>
      </div>
      <div class="col-md-6 pt-0 pb-0 text-right">
        <p class="m-0 worksansr">Telefone: {{ user.rest_home_first_phone }}</p>
        <p class="m-0 worksansr">
          {{ user.rest_home_address }}, {{ user.rest_home_num_address }} -
          {{ user.rest_home_neighborhood }} -
          {{
            user.rest_home_uf && user.rest_home_uf.name
              ? user.rest_home_uf.name
              : ""
          }}
        </p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <v-btn class="btn-cancel mr-2" @click="handleCancel"
          ><i class="fas fa-times mr-2"></i>CANCELAR
        </v-btn>
      </div>
      <div class="col-md-6 text-right" @click="handlePrint">
        <v-btn class="btn-print">IMPRIMIR</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatDate,
  formatMoney,
  numbersOnly,
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

import extenso from "extenso";

import { userData } from "../../../../../lib/functions";

export default {
  name: "Receipt",
  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      items: [],
      user: {},
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    extenso,
    formatDate,
    formatMoney,
    numbersOnly,
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    handleTextValue(item) {
      let { value } = item;

      value = String(value);

      value = formatMoney(value);

      value = String(value).replace(".", "").replace(".", "");

      return extenso(value, {
        number: { decimalSeparator: "comma" },
        mode: "currency",
        currency: { type: "BRL" },
      });
    },
    retrieve() {
      let { data } = this;

      for (let item of data.items) {
        item.value = numbersOnly(item.value);
      }

      this.items = data.items;

      let { user } = userData();

      this.user = user;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handlePrint() {
      let { data } = this;

      let params = {
        id: data.id,
      };

      let route = this.$router.resolve({
        name: "receipt-print",
        params,
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>